"use strict";
import a from "./index.es144.js";
import f from "./index.es154.js";
import r from "./index.es267.js";
function d(e, i) {
  return f(e, new r.classes.URLSearchParams(), {
    visitor: function(t, s, n, o) {
      return r.isNode && a.isBuffer(t) ? (this.append(s, t.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...i
  });
}
export {
  d as default
};
//# sourceMappingURL=index.es266.js.map
